// Documento: Cómo conectar TikTok
// Categoría: TikTok
// Última actualización: 2025-10-15

const document = {
  "id": "conectar-tiktok",
  "title": "Cómo conectar TikTok",
  "category": "TikTok",
  "description": "Guía completa para conectar tu cuenta de TikTok empresarial a Runamatic y comenzar a automatizar tus conversaciones.",
  "explanations": [
    {
      "title": "Requisitos previos: Cuenta de empresa",
      "content": "Para poder automatizar una cuenta de TikTok, esta debe ser una cuenta de tipo empresa. Para habilitar esta opción, acceda a los Ajustes de su cuenta de TikTok.",
      "images": [
        "/documents/tiktok/1.png"
      ]
    },
    {
      "title": "Verificar tipo de cuenta",
      "content": "En Administrar cuenta, la opción 'Cuenta de empresa' debe estar habilitada. Si no lo está, actívela antes de continuar con la conexión.",
      "images": [
        "/documents/tiktok/2.png"
      ]
    }
  ],
  "steps": [
    {
      "title": "Iniciar sesión en TikTok",
      "content": "Asegúrese de tener abierta la sesión de su cuenta de TikTok empresarial en el mismo explorador de internet donde utilizará Runamatic. Esto es fundamental para que la conexión funcione correctamente."
    },
    {
      "title": "Acceder a la configuración de canales",
      "content": "Desde Runamatic, diríjase al menú Ajustes > Canales. Busque la opción TikTok y haga clic en el botón 'Conectar'."
    },
    {
      "title": "Completar la conexión",
      "content": "Siga los pasos que aparecerán en pantalla para autorizar la conexión entre su cuenta de TikTok y Runamatic. Una vez completado el proceso, su cuenta quedará conectada y lista para usar."
    },
    {
      "title": "Funcionalidades disponibles",
      "content": "Por el momento, Runamatic podrá responder mensajes privados y gestionar el tráfico proveniente de TikTok Lead Forms. Las respuestas automáticas a comentarios en posts están planificadas para una futura actualización."
    },
    {
      "title": "Importante: TikTok Lead Forms",
      "content": "TikTok Lead Forms es una herramienta de captura de leads dentro de TikTok. Runamatic puede recibir y procesar automáticamente los leads generados desde esta funcionalidad, permitiéndole iniciar conversaciones automatizadas con nuevos prospectos."
    }
  ],
  "tags": [
    "tiktok",
    "conexión",
    "configuración",
    "empresa",
    "lead forms",
    "mensajes privados"
  ],
  "lastUpdated": "2025-10-15",
  "difficulty": "básico"
};

export default document;

